import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=b8139494&scoped=true"
import script from "./ImageEditor.vue?vue&type=script&lang=js"
export * from "./ImageEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8139494",
  null
  
)

export default component.exports